import { VisitWithLocalMassaging } from '../../../pages/PastVisitsRightPanel';

const VisitDataWrapper = ({
    status,
    children,
}: {
    status: VisitWithLocalMassaging['status'];
    children: JSX.Element;
}): JSX.Element => {
    if (status !== 'BK') {
        return <>{children}</>;
    }
    return (
        <div className="rounded-8 bg-darwin-green-bg-dark py-8 pl-8 pr-16 flex flex-col gap-y-8 -m-8">
            <BookedStatusHeader />
            {children}
        </div>
    );
};

const BookedStatusHeader = () => {
    return (
        <div className="flex flex-row items-center gap-x-4">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                className="w-16 h-16"
                fill="#0F6440"
            >
                <path d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192z" />
            </svg>
            <div className="text-12 text-darwin-neutral-1000 font-400">Upcoming</div>
        </div>
    );
};

export default VisitDataWrapper;
